import { render, staticRenderFns } from "./FormPass.vue?vue&type=template&id=ba390f1e&scoped=true&"
import script from "./FormPass.vue?vue&type=script&lang=js&"
export * from "./FormPass.vue?vue&type=script&lang=js&"
import style0 from "./FormPass.vue?vue&type=style&index=0&id=ba390f1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba390f1e",
  null
  
)

export default component.exports